module.exports = __webpack_public_path__ + "img/268Vlogo.bf6adbc8.png";